module.exports = __webpack_public_path__ + "static/img/indexPic6.0bf830b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/indexPic6.png
// module id = ptmN
// module chunks = 1